export default __webpack_public_path__ + "static/media/vanessa-testimonial-selected.8f2bf1bc.png";